<template>
  <div :style="style.container">
    <ModalSurveyCreationPrimary
      ref="modalSurveyCreation"
      @create-survey="createSurvey"
      @download-survey-template="downloadSurveyTemplate"
    />
    <HeaderLargePrimary :style="style.header">
      Select survey
    </HeaderLargePrimary>
    <AdminSurveyList
      :surveys="surveys"
      @create="openModalToCreateSurvey"
      @select="goToSurveyPage"
    />
    <PaginationPrimary
      v-if="pageCount > 1"
      v-model="page"
      :pageCount="pageCount"
      @change="fetchSurveys(page, pageSize)"
      :style="style.pagination"
    />
  </div>
</template>

<script>
  import ApiSurvey from '@js/api/survey'
  import ApiSurveyDownloadFile from '@js/api/survey-download-file'
  import ApiSurveyFile from '@js/api/survey-file'
  import AdminSurveyList from '@survey/modules/admin-survey-list'
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import ModalSurveyCreationPrimary
    from '@survey/modals/modal-survey-creation-primary'
  import PaginationPrimary from '@modules/v2/pagination/pagination-primary'
  import { downloadCsvFile } from '@js/file-utils'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import { MODAL_WINDOW_NAMES } from '@js/constants'
  import { PAGE_SIZES } from '@js/constants'

  export default {
    name: 'AdminSurveysView',
    components: {
      AdminSurveyList,
      HeaderLargePrimary,
      ModalSurveyCreationPrimary,
      PaginationPrimary,
    },
    data: function () {
      return {
        page: 1,
        pageSize: PAGE_SIZES.SURVEY,
        surveysCount: 0,
        surveys: [],
        style: {
          container: {
            margin: `${Layout.space.xl} auto ${Layout.space.lg}`,
            maxWidth: Layout.container.primary.maxWidth,
            width: '100%',
          },
          header: {
            margin: `0 0 ${Layout.space.md} 0`,
            padding: Layout.container.md.padding,
          },
          pagination: {
            display: 'flex',
            justifyContent: 'center',
            margin: `${Layout.space.lg} 0 0 0`,
            width: '100%',
          },
        },
      };
    },
    mounted: async function () {
      await this.fetchSurveys(1, this.pageSize);
    },
    computed: {
      ...mapGetters('globalVariables', ['getSurveyDownloadFileModeByKey']),
      pageCount: function () {
        return Math.floor((this.surveysCount - 1) / this.pageSize) + 1;
      },
    },
    methods: {
      createSurvey: async function (form) {
        try {
          this.$refs.modalSurveyCreation.isUploading = await true;
          const payload = await form.getPostPayload();
          const api = await new ApiSurveyFile();
          const res = await api.post(payload);
          await this.$refs.modalSurveyCreation.step++;
          await this.updateLocalSurveys(res.data);
        } catch (error) {
          console.error(error);
          this.$store.commit('notification/setWarning', 'Failed to create survey');
        } finally {
          this.$refs.modalSurveyCreation.isUploading = false;
        }
      },
      downloadSurveyTemplate: async function () {
        try {
          const queryParams = await {
            mode: this.getSurveyDownloadFileModeByKey('template').uid,
          };
          const payload = await {};
          const api = await new ApiSurveyDownloadFile();
          const res = await api.post(payload, queryParams);
          await downloadCsvFile(res.data, 'survey_template.csv');
        } catch (error) {
          console.error(error);
          this.$store.commit(
            'notification/setWarning',
            'Failed to download template',
          );
        }
      },
      fetchSurveys: async function (page, pageSize) {
        try {
          const queryParams = {
            page: page,
            pageSize: pageSize,
          };
          const api = await new ApiSurvey();
          const res = await api.get(queryParams);
          this.surveys = await res.data.results;
          this.surveysCount = await res.data.count;
        } catch (error) {
          console.error(error);
          this.$store.commit('notification/setWarning', 'Failed to load surveys');
        }
      },
      goToSurveyPage: function (survey) {
        this.$router.push({
          name: 'admin-survey',
          params: {
            surveyCode: survey.code,
          },
        });
      },
      openModalToCreateSurvey: function () {
        this.$modal.show(MODAL_WINDOW_NAMES.CREATE_SURVEY_PRIMARY);
      },
      updateLocalSurveys: async function (newSurvey) {
        this.page = await 1;
        await this.fetchSurveys(this.page, this.pageSize);
      },
    },
  };
</script>
